import { Component, inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { InicioService } from '../../services/inicio.service';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit{
  public service = inject(InicioService);
  public rutas = inject(Router);

  user: any;
  logeo: boolean = false;
  token: string = ''

  ngOnInit():void {

    if (typeof window !== 'undefined' && !!localStorage.getItem('token')) {
      const storedUser = localStorage.getItem('usuSesion');
      if (storedUser != null) {
        this.user = JSON.parse(storedUser);
        this.service.updateLogeo(this.user);
      } else {
        // Si no hay usuario almacenado, realizar la lógica de autenticación
        this.user = null;
        this.service.updateLogeo(this.user);
        //console.log('no hay usuario')
      }
    }

    //console.log('no hay usuario: ', this.user)

    this.service.user$.subscribe(user => {
      this.user = user;
    });

  }

  /*
  alerta(content: TemplateRef<any>) {
		this.modalService.open(content, { centered: true });
	}
    */

  async cerrarSesion(){
    await this.service.cerrarSesion(this.user.id_institucional).subscribe({
      next:(dt)=>{
        if(dt.data){
          this.rutas.navigate(['/']);
        }
      }
    })
  }





  login(){
    this.rutas.navigate(['/login']);
  }

}
